import { Cohort } from 'nove8/constants/root-constants'
import { addAmplitudeLogger } from 'nove8/helpers/addAmplitudeLogger'
import { addRudderstackLogger } from 'nove8/helpers/addRudderstackLogger'
import { getAmplitudeApiKey } from 'nove8/helpers/getAmplitudeApiKey'
import { getCommonEventProps } from 'nove8/helpers/getCommonEventProps'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { eventLogger } from 'services/eventLogger.service'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useEventLoggerInitialization = (): void => {
  const { search } = useLocation()
  const {
    cohort,
    leadId,
    country,
    firebaseRemoteConfig,
    growthbook,
    isEventLoggerInitialized,
    geoRegion,
  } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || '',
      leadId: state.lead?.id,
      country: state.lead?.country || '',
      firebaseRemoteConfig: state.firebaseRemoteConfig,
      growthbook: state.growthbook,
      isEventLoggerInitialized: state.isEventLoggerInitialized,
      geoRegion: state.geoRegion,
    })),
  )
  const { language, isCookieyesConsent } = useZustandSessionStore(
    useShallow((state) => ({
      language: state.language,
      isCookieyesConsent: state.cookieyesConsent,
    })),
  )

  useEffect(() => {
    if (!isCookieyesConsent) {
      eventLogger.init([], {}, {})
      useZustandStore.setState({ isEventLoggerInitialized: false })
      return
    }

    if (
      isEventLoggerInitialized ||
      !leadId ||
      !language ||
      !firebaseRemoteConfig ||
      !growthbook
    ) {
      return
    }

    const searchParams = new URLSearchParams(search)
    const searchParamsEntries = Object.fromEntries(searchParams.entries())

    eventLogger.init(
      [],
      searchParamsEntries,
      getCommonEventProps(searchParamsEntries),
    )

    addAmplitudeLogger({
      amplitudeApiKey: getAmplitudeApiKey(cohort as Cohort),
      cohort: cohort as Cohort,
      utmTags: searchParamsEntries,
      uuid: leadId,
      firebaseRemoteConfig,
      growthbook,
      language,
      country,
    })
    addRudderstackLogger({
      cohort: cohort as Cohort,
      utmTags: searchParamsEntries,
      uuid: leadId,
      firebaseRemoteConfig,
      growthbook,
      language,
      country,
    })

    useZustandStore.setState({ isEventLoggerInitialized: true })
  }, [
    cohort,
    country,
    firebaseRemoteConfig,
    growthbook,
    isEventLoggerInitialized,
    language,
    leadId,
    search,
    isCookieyesConsent,
    geoRegion,
  ])
}
